export enum TicketSelectionMode {
  Splitted = -1,
  Single = 0,
  Combi = 1,
}
